import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronUp, ChevronDown } from "lucide-react";

const Accordion = ({ items }) => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(null);

  const onTitleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  // Add CSS for the heartbeat animation
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes heartbeat { 
        0% { 
          box-shadow: 0 0 0 0 rgba(229, 62, 62, 0.9);
        } 
        30% {
          box-shadow: 0 0 0 18px rgba(229, 62, 62, 0);
        }
        40% {
          box-shadow: 0 0 0 0 rgba(229, 62, 62, 0);
        }
        60% {
          box-shadow: 0 0 0 10px rgba(229, 62, 62, 0);
        }
        75% {
          box-shadow: 0 0 0 0 rgba(229, 62, 62, 0);
        }
        100% { 
          box-shadow: 0 0 0 0 rgba(229, 62, 62, 0.9);
        } 
      } 
      
      .heartbeat-animation { 
        animation: heartbeat 3s ease-out infinite; 
        position: relative; 
        z-index: 1; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
      <div className="colorBG">
        <div className="container mx-auto ">
          <div className="accordion">
            <div className="section-title whitespace-no-wrap">
              <h2>Besoin d'en savoir plus ?</h2>
            </div>
            {items.map((item, index) => {
              const isActive = activeIndex === index;
              return (
                  <div
                      key={item.title}
                      className={`accordion-item ${isActive ? "active" : ""}`}
                  >
                    <div
                        className="accordion-title"
                        onClick={() => onTitleClick(index)}
                    >
                      <h3>{item.title}</h3>
                      <span className="accordion-icon">
                    {isActive ? <ChevronUp /> : <ChevronDown />}
                  </span>
                    </div>
                    <div className="accordion-content">
                      <div className="accordion-inner">
                        {item.content.split("\n").map((paragraph, i) => (
                            <p key={i}>{paragraph}</p>
                        ))}
                      </div>
                    </div>
                  </div>
              );
            })}
            <div className="flex justify-center mt-4">
              <button
                  className="banner-btn text-white px-8 py-3 button-red rounded-full font-medium transition-all hover:shadow-lg heartbeat-animation"
                  onClick={() => navigate("/contact")}
              >
                Prendre rendez-vous
              </button>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Accordion;